import {LogsComponent} from './server-logs/logs.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CentralComponent} from './central/central.component';
import {CarsComponent} from './cars/cars.component';
import {CarsExternalComponent} from './cars-external/cars-external.component';
import {DriversComponent} from './drivers/drivers.component';
import {MapComponent} from './map/map.component';
import {LoginComponent} from './login/login.component';
import {OverviewComponent} from './overview/overview.component';
import {AirportcarsComponent} from './airportcars/airportcars.component';
import {AirportKioskComponent} from './airport-kiosk/airport-kiosk.component';
import {VouchersComponent} from './vouchers/vouchers.component';
import {OrdersComponent} from './orders/orders.component';
import {PosComponent} from './pos/pos.component';
import {ProfileComponent} from './profile/profile.component';
import {MessagesComponent} from './messages/messages.component';
import {UsersComponent} from './users/users.component';
import {PermissionGuard} from './services/permission.guard';
import {AdminPermissions} from './models/admin-permissions';
import {SessionGuard} from './services/session.guard';

const routes: Routes = [
    {
        path: 'central', component: CentralComponent, canActivate: [SessionGuard], children: [
            {path: 'overview', component: OverviewComponent, data: {title: 'Overview'}},
            {
                path: 'cars', component: CarsComponent, canActivate: [PermissionGuard],
                data: {title: 'Cars', permissions: [AdminPermissions.ViewCars]}
            },
            {
                path: 'cars-external', component: CarsExternalComponent, canActivate: [PermissionGuard],
                data: {title: 'Cars External', permissions: [AdminPermissions.ViewCars]}
            },
            {
                path: 'driver', component: DriversComponent, canActivate: [PermissionGuard],
                data: {
                    title: 'Driver',
                    permissions: [AdminPermissions.ViewCars, AdminPermissions.ViewAirportCars]
                }
            },
            {
                path: 'driver/:driverIdentifier', component: DriversComponent, canActivate: [PermissionGuard],
                data: {
                    title: 'Driver',
                    permissions: [AdminPermissions.ViewCars, AdminPermissions.ViewAirportCars]
                }
            },
            {
                path: 'airportcars', component: AirportcarsComponent, canActivate: [PermissionGuard],
                data: {title: 'Airport Cars', permissions: [AdminPermissions.ViewAirportCars]}
            },
            {
                path: 'airport-kiosk',
                component: AirportKioskComponent,
                canActivate: [PermissionGuard],
                data: {
                    title: 'Airport Kiosk',
                    permissions: [AdminPermissions.ViewKioskLogs, AdminPermissions.RestartKiosk]
                }
            },
            {
                path: 'vouchers', component: VouchersComponent, canActivate: [PermissionGuard],
                data: {title: 'Vouchers', permissions: [AdminPermissions.ViewVouchers]}
            },
            {
                path: 'orders', component: OrdersComponent, canActivate: [PermissionGuard],
                data: {title: 'Orders', permissions: [AdminPermissions.ViewOrders]}
            },
            {
                path: 'pos', component: PosComponent, canActivate: [PermissionGuard],
                data: {title: 'POS', permissions: [AdminPermissions.ViewPos]}
            },
            {
                path: 'map', component: MapComponent, canActivate: [PermissionGuard],
                data: {title: 'Map', permissions: [AdminPermissions.ViewMap]}
            },
            {path: 'server-logs', component: LogsComponent, canActivate: [PermissionGuard],
                data: {title: 'Server Logs', permissions: [AdminPermissions.ViewServerLogs]}},
            {path: 'profile', component: ProfileComponent, data: {title: 'My Profile'}},
            {
                path: 'users', component: UsersComponent, canActivate: [PermissionGuard],
                data: {title: 'Users', permissions: [AdminPermissions.ViewUsers]}
            },
            {
                path: 'messages',
                component: MessagesComponent,
                canActivate: [PermissionGuard],
                data: {
                    title: 'Messages',
                    permissions: [AdminPermissions.BroadcastDriverMessage, AdminPermissions.SendCarMessage]
                }
            },
            {path: '**', component: OverviewComponent, data: {title: 'Overview'}},
        ]
    },
    {path: 'login', component: LoginComponent},
    {path: '', component: LoginComponent},
    {path: '**', component: LoginComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
